import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children?: ReactNode;
  wrapClass?: string;
  fontSize?: "compact" | "normal";
}

interface State {
  hasError: boolean;
}

class ErrorBoundaryForSection extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div
          className={`flex flex-col items-center justify-center bg-gray-200 text-gray-400 ${this?.props?.fontSize === "compact" ? "text-[8px] leading-[10px]" : ""} rounded-lg w-full p-2 text-center ${this?.props?.wrapClass || ""}`}
        >
          <h3 className="font-bold">This section is unavailable</h3>
          <p>
            An error occurred while loading this section. Please try again
            later.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundaryForSection;
